// Import React.
import React from "react";

// Import components.
import { FaqGrid } from "global/components/FaqGrid";



// Export the FAQ section.
export const FaqSection = ({
    sections = [],
}) => {

    // Return nothing when no FAQ sections have been supplied.
    if (!Array.isArray(sections) || sections.length === 0) { return null; }



    // Render the FAQ section.
    return (

        // Add the FAQ identifier used by the navigation button.
        <section
            className="landing-faq"
            id="faq"
            aria-labelledby="landing-faq-title"
        >

            {/* Constrain the FAQ content width. */}
            <div className="landing-faq__inner">

                {/* Render the FAQ heading. */}
                <h2
                    className="landing-faq__title"
                    id="landing-faq-title"
                >
                    Frequently Asked Questions
                </h2>

                {/* Render the reusable FAQ grid. */}
                <FaqGrid
                    sections={sections}
                    headingTag="h3"
                />

            </div>

        </section>

    );

};